<div class="container my-5 blog-section">
  <h1 class="main-title text-center  text-uppercase fw-bold">
    {{ ('BLOG.TITLE' | translate).replace('Daily ', '').replace('يومياً ', '').replace('Quotidien ', '') }}
  </h1>

  <p-carousel [value]="blog" [numVisible]="3" [numScroll]="1" [circular]="true" [showIndicators]="false"
    [showNavigators]="blog.length > 1" [autoplayInterval]="2000" [responsiveOptions]="responsiveOptions"
    styleClass="custom-blog-carousel" dir="ltr">
    <ng-template pTemplate="item" let-item>
      <div class="carousel-item-wrapper blog-card" (click)="viewBlog(item.id)">
        <img [src]="item.img" alt="Blog image" class="carousel-image blog-image" />
        <p class="blog-category text-uppercase fw-semibold mb-1 mt-2">{{ item.category }}</p>
        <h6 class="blog-title mb-2">{{ item.title }}</h6>
        <p class="blog-author text-muted mb-0">By {{ item.by }}</p>
      </div>
    </ng-template>
  </p-carousel>

  <div class="text-center mt-4">
    <button id="viewBlog" routerLink="/blogs" class="btn view-all-btn">{{ 'BLOG.VIEW_ALL' | translate }}</button>
  </div>
</div>